import { createFileRoute } from "@tanstack/react-router";
import { PpcLandingPage, buildPpcHead } from "@/components/PpcLandingPage";
import { PPC_LANDING_PAGES } from "@/lib/ppcLandingData";

const SLUG = "website-repairs";
const cfg = PPC_LANDING_PAGES[SLUG];

export const Route = createFileRoute("/lp/website-repairs")({
  head: () => buildPpcHead({ slug: SLUG, title: cfg.metaTitle, description: cfg.metaDescription }),
  component: () => <PpcLandingPage slug={SLUG} {...cfg} />,
});
